import React from 'react';
import '../style/Preloader.css';

const Preloader = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Preloader;